import { render, staticRenderFns } from "./msw-app-content-open-route.vue?vue&type=template&id=68e81dbc&"
import script from "./msw-app-content-open-route.vue?vue&type=script&lang=tsx&"
export * from "./msw-app-content-open-route.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-app-content-open-route.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports